import type { BugReport, BugReportScreenshot } from 'clients/bug-report'
import type { Attachment } from 'features/bug-report/types'
import { dataUrlToBytes } from 'features/bug-report/utils/encoding'

type Reporter = {
  firstName: string
  lastName: string
  email: string
}

type Args = {
  message: string
  attachments: Attachment[]
  reporter: Reporter | null
  projectId: string | undefined
  url: string
  pathname: string
}

export function buildBugReport({
  message,
  attachments,
  reporter,
  projectId,
  url,
  pathname,
}: Args): BugReport {
  const screenshots: BugReportScreenshot[] = attachments.map((a) => ({
    filename: a.filename,
    contentType: a.contentType,
    data: dataUrlToBytes(a.dataUrl),
  }))
  const fullName = reporter
    ? `${reporter.firstName} ${reporter.lastName}`.trim()
    : ''
  return {
    message,
    reporter: {
      name: fullName || reporter?.email || 'unknown',
      email: reporter?.email ?? '',
    },
    url,
    pathname,
    tags: projectId ? { feedback_project_id: projectId } : {},
    screenshots,
  }
}
